import React from "react";
import { Search } from "lucide-react";

const ALL = [["urgent", "Most urgent"], ["az", "Name A–Z"], ["za", "Name Z–A"], ["new", "Newest"], ["old", "Oldest"], ["owed", "Most owed"]];
const ts = (v) => (v ? new Date(v).getTime() || 0 : 0);

/** Search by name + sort. get: { name(r), date?(r), owed?(r) }; "urgent" keeps the list's own most-urgent order. */
export function sortRows(rows, get, sort, q) {
  const needle = (q || "").trim().toLowerCase();
  const out = needle ? rows.filter((r) => (get.name(r) || "").toLowerCase().includes(needle)) : [...rows];
  const by = {
    az: (a, b) => (get.name(a) || "").localeCompare(get.name(b) || ""),
    za: (a, b) => (get.name(b) || "").localeCompare(get.name(a) || ""),
    new: (a, b) => ts(get.date(b)) - ts(get.date(a)),
    old: (a, b) => (ts(get.date(a)) || Infinity) - (ts(get.date(b)) || Infinity),
    owed: (a, b) => (get.owed(b) || 0) - (get.owed(a) || 0),
  }[sort];
  return by ? out.sort(by) : out;
}

export function ListTools({ prefix, q, setQ, sort, setSort, get, placeholder = "Search by name", className = "" }) {
  const tabs = ALL.filter(([k]) => (k !== "new" && k !== "old") || get.date).filter(([k]) => k !== "owed" || get.owed);
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={`${prefix}-list-tools`}>
      <label className="relative">
        <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-3 w-3 text-nex-muted" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} data-testid={`${prefix}-search`}
          className="pl-7 pr-2 py-1.5 w-52 bg-black/40 border border-white/10 rounded-sm text-sm text-nex-silver focus:outline-none focus:border-nex-gold/60" />
      </label>
      <div className="flex flex-wrap gap-1" role="tablist">
        {tabs.map(([k, l]) => (
          <button key={k} type="button" role="tab" aria-selected={sort === k} onClick={() => setSort(k)} data-testid={`${prefix}-sort-${k}`}
            className={`px-2.5 py-1 rounded-full border font-mono text-[9px] tracking-[0.14em] uppercase transition-colors ${sort === k ? "border-nex-gold text-nex-gold bg-nex-gold/10" : "border-white/10 text-nex-muted hover:text-nex-silver"}`}>{l}</button>))}
      </div>
    </div>
  );
}
